import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Renderer2, SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {LIST_TYPE} from "../../defines/client.const";
import {DialectHistoryService} from "../../services/dialect/dialect-history.service";
import {WordHistoryService} from "../../services/word/word-history.service";
import {DialectLinkMixinFunction} from '../../mixin/dialect-link.mixin';
import {MultiLinkMixinFunction} from '../../mixin/multi-link.mixin';
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";


/**
 * 2개의 mixin을 모두 연결한다.
 * (1) MultiLinkMixinFunction
 * (2) DialectLinkMixinFunction
 */
const linkMixin = DialectLinkMixinFunction(
  MultiLinkMixinFunction(
    class Parent {
      constructor(
        public router: Router,
        public wHistorySvc: WordHistoryService,
        public dHistorySvc: DialectHistoryService,
        public lm: LayoutMgrService,
        public dynamicSvc: DynamicComponentService,
      ) {}
    }
  )
);

function isWordLink(tar: any): boolean {
  return tar instanceof HTMLAnchorElement && tar.className === 'wordlink';
}

@Component({
  selector: 'app-link-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container #container></ng-container>
    <div [innerHTML]="content | keepHtml"></div>
  `,
  styles: [`
    /* 모든 app-link-content 본문에 Noto Serif KR Regular 적용 (#722 후속) */
    div {
      font-family: "NotoSerifKR", "Jigmo";
    }
  `],
})
export class LinkContentComponent extends linkMixin implements OnInit, OnDestroy , OnChanges {
  @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() content: string | null = null;
  @Input() popupAlignLeftSelector: string | null = null; // 팝업창 왼쪽 위치를 맞출 기준 요소의 CSS 선택자
  @Input() popupLeftOffset = 0; // 기준 요소 또는 팝업에 적용할 수평 보정값 (px)
  @Input() popupZIndex = 0; // 링크 팝업 host 요소의 z-index (0이면 미적용)

  private unlisten: (() => void) | null = null;

  constructor(
    public override router: Router,
    public override wHistorySvc: WordHistoryService,
    public override dHistorySvc: DialectHistoryService,
    public override lm: LayoutMgrService,
    public override dynamicSvc: DynamicComponentService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, wHistorySvc, dHistorySvc, lm, dynamicSvc);
  }

  ngOnInit(): void {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      let tar = event.target;

      // TODO: tar.className === 'hanja-size' 는 추후에 제거해야할지 고민이 필요. 링크 안의 테그가 다양해지면 매번 여기에 추가하는 것도 번거로움.
      if (isWordLink(tar) || (tar.className === 'hanja-size' && isWordLink(tar.parentElement))) {

        // 링크 안에 한자를 클릭한 경우에는 부모 요소로 대체한다.
        if ((tar.className === 'hanja-size' && isWordLink(tar.parentElement))) {
          tar = tar.parentElement;
        }

        event.preventDefault();
        event.stopPropagation();
        this.globalEventSvc.Click(event, true);

        console.log('anchor click = ', event, event.target.innerText);

        const url = decodeURI(tar.pathname);
        console.log('url = ', url);

        const href = tar.getAttribute('href');
        if (href) {
          const dispWord = event.target.innerText.replace(/[:_\/-]/g, "");
          console.warn('dispWord = ', dispWord);
          // TODO:
          this.OpenMultiLink(
            href,
            this.container,
            dispWord,
            this.popupAlignLeftSelector ? 0 : this.popupLeftOffset,
            this.popupZIndex,
            this.GetPopupLeftTarget()
          ).subscribe({
            error: (err) => console.error('LinkContentComponent: failed to open link popup', err),
          });
        }
        else {
          throw new Error('LinkContentComponent: href is null');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

  private GetPopupLeftTarget(): number | null {
    if (!this.popupAlignLeftSelector) {
      return null;
    }

    const hostEl = this.elementRef.nativeElement as HTMLElement;
    const rootEl = hostEl.closest('app-dialect-detail') ?? document;
    const targetEl = rootEl.querySelector(this.popupAlignLeftSelector) as HTMLElement | null;
    if (!targetEl) {
      console.warn(`LinkContentComponent::GetPopupLeftTarget() selector "${this.popupAlignLeftSelector}" not found`);
      return null;
    }

    const targetRect = targetEl.getBoundingClientRect();
    return targetRect.left + this.popupLeftOffset;
  }

  /**
   * content 값의 갱신 여부를 확인하기 위해서 추가한 함수
   * ToDo: 차후에 삭제할 것
   */
  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['content'];

    // if (change) {
    //   console.warn('LinkContentComponent::ngOnChanges() changes[content] =', change, change.previousValue, change.currentValue);
    // }
    // else {
    //   console.warn('LinkContentComponent::ngOnChanges() changes[content] =', change);
    // }
  }
}
